export const OUTCOME_LABELS = {
  ENROLLED: "Enrolled",
  FIRST_OUTREACH_COMPLETE_NO_RESPONSE: "1st Outreach Complete – No Response...",
  SECOND_OUTREACH_COMPLETE_MEMBER_NON_RESPONSIVE:
    "2nd Outreach Complete – Member Non-Responsive...",
  SCHEDULED_CALLBACK: "Scheduled Callback",
  NOT_ENROLLED: "Not Enrolled",
  MEMBER_DECLINED: "Member Declined",
  DO_NOT_CALL: "Do Not Call",
  NO_OUTCOME: "No Outcome",
};

export const AUTHORIZED_CAREGUIDES = [
  "aagrawal@lucyrx.com",
  "ssharma@lucyrx.com",
  "tbeeson@lucyrx.com",
  "dnethi@lucyrx.com",
  "apetla@lucyrx.com",
  "jmurray@lucyrx.com",
  "rlgarza@lucyrx.com",
];
export const DEFAULT_OUTCOMES = [
  { label: "Enrolled", count: "-", subReasons: [] },
  {
    label: "1st Outreach Complete – No Response...",
    count: "-",
    subReasons: [],
  },
  {
    label: "2nd Outreach Complete – Member Non-Responsive...",
    count: "-",
    subReasons: [],
  },
  { label: "Scheduled Callback", count: "-", subReasons: [] },
  { label: "Not Enrolled", count: "-", subReasons: [] },
  { label: "Member Declined", count: "-", subReasons: [] },
  { label: "Do Not Call", count: "-", subReasons: [] },
  { label: "No Outcome", count: "-", subReasons: [] },
].map((o) => ({ ...o, color: null }));

export const DEFAULT_PROGRAMS = [
  { name: "Biosimilars", eligible: "", enrolled: "" },
  { name: "International Sourcing", eligible: "", enrolled: "" },
  { name: "Copay Assist", eligible: "", enrolled: "" },
  { name: "GLP-1", eligible: "", enrolled: "" },
  { name: "PAP", eligible: "", enrolled: "" },
  { name: "ECMP", eligible: "", enrolled: "" },
  { name: "Women's Health Program", eligible: "", enrolled: "" },
];

export const DEFAULT_CAREGIVERS = [
  {
    assignedCareGuide: "Unassigned",
    total: "-",
    completed: "-",
    notCompleted: "-",
  },
];
